module.exports = __webpack_public_path__ + "static/media/25seguro.afad605.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/25seguro.mp4
// module id = 728
// module chunks = 1